const equipments = {
	title: "Equipments",
	stitle: "Equipment",
	new_title: "New Equipment",
	edit_title: "Edit Equipment: {name}",
	list_title: "List of Equipment",
	list_subtitle: "Manage equipment",
	id: "ID",
	serial_number: "Serial number",
	model_details: "Model details",
	internal_nb: "Internal NB",
	year: "Year",
	inspection_interval: "Inspection interval",
	next_inspection_date: "Next inspection date",
	qr_code: "QR Code",
	swl: "SWL",
	responsible_by: "Responsible by",
	company_id: "Company ID",
	notes: "Notes",
	urls: "Web URLs",
};
export default equipments;